import * as i1 from 'angular-oauth2-oidc';
import { OAuthStorage } from 'angular-oauth2-oidc';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
class AppOAuthStorage extends OAuthStorage {
  constructor(clientName, appName, storage) {
    super();
    this.clientName = clientName;
    this.appName = appName;
    if (storage) {
      this.storage = storage;
    } else if (typeof sessionStorage !== 'undefined') {
      this.storage = sessionStorage;
    } else if (typeof localStorage !== 'undefined') {
      this.storage = localStorage;
    }
  }
  getItem(key) {
    return this.storage.getItem(`${this.clientName}-${key}`);
  }
  setItem(key, data) {
    this.storage.setItem(`${this.clientName}-${key}`, data);
  }
  removeItem(key) {
    this.storage.removeItem(`${this.clientName}-${key}`);
  }
  clear() {
    this.clearInternal(`${this.clientName}-`);
  }
  getAppItem(key) {
    return this.storage.getItem(`${this.clientName}-${this.appName}-${key}`);
  }
  setAppItem(key, data) {
    this.storage.setItem(`${this.clientName}-${this.appName}-${key}`, data);
  }
  removeAppItem(key) {
    this.storage.removeItem(`${this.clientName}-${this.appName}-${key}`);
  }
  clearApp() {
    this.clearInternal(`${this.clientName}-${this.appName}-`);
  }
  clearInternal(keyPrefix) {
    [...Array(this.storage.length)].map((_, i) => this.storage.key(i) ?? '').filter(k => k.startsWith(keyPrefix)).forEach(k => this.storage.removeItem(k));
  }
}
const SkipAuthHeader = 'HPO-Skip-Authorization';
let AuthorizationInterceptor = /*#__PURE__*/(() => {
  class AuthorizationInterceptor {
    constructor(authStorage) {
      this.authStorage = authStorage;
    }
    intercept(req, next) {
      // Does not add token if it is already present or request has skip-auth header
      if (req.headers.has('Authorization') || req.headers.has(SkipAuthHeader)) {
        // Remove skip-auth header from outgoing request
        if (req.headers.has(SkipAuthHeader)) {
          const cloneHeaders = req.headers.delete(SkipAuthHeader);
          const cloneReq = req.clone({
            headers: cloneHeaders
          });
          return next.handle(cloneReq);
        }
        return next.handle(req);
      }
      const accessToken = this.authStorage.getItem('access_token');
      // If token was found add it to the request...
      if (accessToken) {
        // Clone headers and set Authorization header with access_token value
        const cloneHeaders = req.headers.set('Authorization', `Bearer ${accessToken}`);
        const cloneReq = req.clone({
          headers: cloneHeaders
        });
        return next.handle(cloneReq);
      }
      // ... or if wasn't, just execute the original request
      return next.handle(req);
    }
    static {
      this.ɵfac = function AuthorizationInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AuthorizationInterceptor)(i0.ɵɵinject(i1.OAuthStorage));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AuthorizationInterceptor,
        factory: AuthorizationInterceptor.ɵfac
      });
    }
  }
  return AuthorizationInterceptor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AppOAuthStorage, AuthorizationInterceptor };
